import Link from 'next/link';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { ScrollableRecord, Option } from 'src/types';
import OptionCard from 'src/components/OptionCard';
import ScrollableSection from 'src/components/ScrollableSection';

type Props = {
  totalCount: number;
  seeAllUrl?: string;
  perSlide?: number;
  collection: ScrollableRecord;
  isGiftExperience?: boolean;
  options: Option[];
  renderTitle: () => JSX.Element;
  renderBtnViewAll?: () => JSX.Element;
  infinite?: boolean;
  useHtmlLink?: boolean;
  hidePrice?: boolean;
  scrollContainerClassName?: string;
};

const ScrollableCollectionOptions: React.FC<Props> = ({
  totalCount,
  collection,
  seeAllUrl,
  isGiftExperience,
  options,
  renderTitle,
  perSlide = 3,
  renderBtnViewAll,
  infinite = true,
  useHtmlLink,
  hidePrice,
  scrollContainerClassName
}) => {
  const numOption = options.length;
  const isGift = isGiftExperience || !!collection.giftCountryId;

  return options.length > 0 ? (
    <div className="container tw-px-4 tw-relative tw-mb-6 md:tw-mb-12">
      <ScrollableSection
        totalCount={totalCount}
        seeAllUrl={seeAllUrl}
        numRecord={numOption}
        perSlide={perSlide}
        renderTitle={renderTitle}
        infinite={infinite}
        hasBlankCard={totalCount > numOption && !!seeAllUrl}
        scrollContainerClassName={scrollContainerClassName}
      >
        <div className="tw-flex tw-flex-nowrap tw--mx-1.5 md:tw--mx-4">
          {options.map((option) => (
            <OptionCard
              key={option.id}
              option={option}
              colClass="js-card-scrollable card-option-scrollable"
              isGift={isGift}
              useHtmlLink={useHtmlLink}
              hidePrice={hidePrice}
            />
          ))}

          {totalCount > numOption && seeAllUrl && (
            <div className="card-option-scrollable card-option-scrollable-blank">
              <div className="tw-border-2 tw-rounded-lg tw-border-brand-green tw-bg-brand-navy tw-relative tw-h-full tw-cursor-pointer">
                <Link legacyBehavior prefetch={false} href={seeAllUrl} passHref>
                  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full">
                    <div className="tw-font-semibold tw-font-styleSans tw-text-brand-green tw-text-lg md:tw-text-xl">see more <HiOutlineArrowNarrowRight /></div>
                  </div>
                </Link>
              </div>
            </div>
          )}
        </div>
      </ScrollableSection>

      {typeof renderBtnViewAll === 'function' ? (
        renderBtnViewAll()
      ) : null}
    </div>
  ) : <></>;
};

export default ScrollableCollectionOptions;
